import _Set from "@babel/runtime-corejs3/core-js/set";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
import { DOCUMENT_CLASSIFICATIONS } from "../constants";
import Handlebars from "handlebars";
import i18n from "@Shared/@i18n";
import Vue from "vue";
import { find } from "lodash";
export const documentTypeSelect = (requestedDocuments = [], onlyNotRequested) => {
  var _context2;
  //You can upload ANY document type (Not completed) -> onlyNotRequested false
  //You can request ONLY documents not already requested  (Not completed) -> onlyNotRequested true
  //Clients can only upload requested documents
  const {
    accountDetails: {
      accountType
    }
  } = Vue.auth.session.get();
  const allClassifications = new _Set(_Object$keys(DOCUMENT_CLASSIFICATIONS));
  const requestedClassifications = new _Set(_mapInstanceProperty(requestedDocuments).call(requestedDocuments, req => req.classificationType));
  let result = {};
  const options = [];
  if (accountType === "client") {
    result = new _Set(requestedClassifications);
  } else if (onlyNotRequested == "true") {
    var _context;
    result = new _Set(_filterInstanceProperty(_context = [...allClassifications]).call(_context, x => !requestedClassifications.has(x)));
  } else {
    result = new _Set(allClassifications);
  }

  //Alphabetical order of classification types
  _sortInstanceProperty(_context2 = [...result]).call(_context2).forEach(value => {
    const complete = find(requestedDocuments, {
      status: "complete",
      classificationType: value
    });
    if (!complete) options.push(`<option value="${value}"> ${DOCUMENT_CLASSIFICATIONS[value]} </option>`);
  });
  return new Handlebars.SafeString(options.join("\n"));
};
export const orderAlphabetically = obj => {
  var _context3;
  const ordered = {};
  _sortInstanceProperty(_context3 = _Object$keys(obj)).call(_context3).forEach(function (key) {
    ordered[key] = obj[key];
  });
  return ordered;
};
export const classificationType = type => DOCUMENT_CLASSIFICATIONS[type] || type;
export const countComments = (doc, visible = true) => {
  if (!doc.comments || !doc.comments.length || doc.comments.length === 0) return i18n.t("documents.addAComment");
  const length = doc.comments.length;
  return visible ? i18n.tc("documents.showComment", length, {
    length
  }) : i18n.tc("documents.hideComment", length, {
    length
  });
};
export const humanFileSize = (bytes, si = true, dp = 1) => {
  const thresh = si ? 1000 : 1024;
  if (Math.abs(bytes) < thresh) {
    return bytes + " B";
  }
  const units = si ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"] : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
  let u = -1;
  const r = 10 ** dp;
  do {
    bytes /= thresh;
    ++u;
  } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);
  return bytes.toFixed(dp) + " " + units[u];
};
export const registerHandlebarHelpers = _Handlebars => {
  _Handlebars.registerHelper("documentTypeSelect", documentTypeSelect);
  _Handlebars.registerHelper("orderAlphabetically", orderAlphabetically);
  _Handlebars.registerHelper("classificationType", classificationType);
  _Handlebars.registerHelper("countComments", countComments);
  _Handlebars.registerHelper("humanFileSize", humanFileSize);
};